<template>
  <main>
    <crumbs :crumbs="crumbs"></crumbs>
    <div class="result">
      <div class="clear branch">
        <div class="swiper-container" id="swiper-plan">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in branch" @click="changeTab(item)">
              <div class=" item" :style="{backgroundImage:'url('+(tab.id == item.id ? item.bg2 : item.bg)+')'}" :class="[tab.id == item.id ? 'active' : '']">
                <div class="cen">
                  <div class="middle">
                    <div class="icon"><img :src="item.icon" alt=""></div>
                    <div class="icon icon-a"><img :src="item.image" alt=""></div>
                    <div class="tit">{{ item.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title-box">
        <div class="left date">08/21</div>
        <div class="left title">
          <div class="tit">进化 乘势而上</div>
          <div class="min-tit">2026戴尔科技峰会暨「进化者」论坛</div>
        </div>
      </div>
      <div class="list">
        <div class="clear item fuck-your-sister" v-for="(item,index) in topic_filter" :class="[tool.array.inArray(live_active,sessionStatus(item,index)) ? 'active' : '']"
             @click="toSession(item,index)">
          <div class="left time-box">
            <div class="line line-1"></div>
            <div class=" time"><i></i>
              <div class="t">{{ tool.date.formatDate("H:i", item.live_start) }}<br/>-<br/>{{ tool.date.formatDate("H:i", item.live_end) }}</div>
            </div>
            <div class="line line-2"></div>
          </div>
          <div class="left info-box">
            <div class=" info">
              <div class="title">{{ item.title }}</div>
              <div class="speaker">
                <div class="ll" v-for="(v,i) in item.speaker" v-if="v.username"><span>{{ v.username }}</span><i v-if="v.job">|</i><span v-html="v.job"></span></div>
              </div>
              <div class="issue" v-if="item.issue">
                <div class="ll" v-for="(v,i) in item.issue">
                  <div class="tit">{{ i }}</div>
                  <div class="speaker-ll" v-for="(vv,ii) in v" v-if="vv.username"><span>{{ vv.username }}</span><i v-if="vv.job">丨</i><span v-html="vv.job"></span></div>
                </div>
              </div>
              <div class="status-box">
                <div class="status" :class="[tool.array.inArray(live_active,sessionStatus(item,index)) ? 'active' : '']">
                  <p>{{ statusText(sessionStatus(item, index)) }}</p>
                </div>
                <div class="star " :class="[inStar(item) ? 'active' : '']" @click.stop="star(item)">
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tips" v-if="topic_filter.length > 0"><i>* </i>实际日程以直播当天为准</div>
      <div class="data-loading" v-if="data_loading">
        <loading></loading>
      </div>
    </div>
  </main>
</template>

<script>
import Crumbs from "../../components/m/Crumbs";
import Loading from "../../components/m/Loading";
export default {
	name: 'plan',
	data() {
		return {
			query:"",
			key:"",
			room_list:[],
			room:{},
			session:[],
			topic:[],
			data_loading:true,
			service_time:0,

			time_list:[],
			now_time:0,
			live_active:[2,3,5],
			star_list:[],

			branch:[
				{id:1,title:"主会场",icon:require('@/assets/image/2022/17.png'),image:require('@/assets/image/2022/18.png'),bg:require('@/assets/image/2022/16.png'),bg2:require('@/assets/image/2022/15.png')},
				{id:2,title:"第二现场",icon:require('@/assets/image/2022/19.png'),image:require('@/assets/image/2022/21.png'),bg:require('@/assets/image/2022/20.png'),bg2:require('@/assets/image/2022/22.png')},
			],
			tab:{id:1},
		}
	},
	components:{
		Loading,
		Crumbs
	},
	computed:{
		week_array(){
			return  ["星期日","星期一","星期二","星期三","星期四","星期五","星期六",]
		},
		crumbs(){
			return {title:"主会场",min_title:"KEYNOTE"}
		},
		is_login(){
			return this.util.getAccessToken()
		},
		topic_filter(){
			return this.topic.filter((item,index)=>{
				return Number(item.type) === Number(this.tab.id);
			})
		}
	},
	watch:{
		now_time(newVal,oldVal){
			if(newVal > oldVal && this.util.inArray(newVal,this.time_list)){
				this.getTopic();
			}
		}
	},
	methods: {
		swiperInit(){
			this.swiper = new Swiper('#swiper-plan',{
				initialSlide:0,
				slidesPerView:3,
				spaceBetween: 15,
				slidesOffsetAfter:2,
				watchOverflow:true,
				slideToClickedSlide:true,
				observer:true,
				observeSlideChildren:true,
			})
		},
		changeTab(item){
			// if(item.id === 2){
			// 	this.util.showWait(true);
			// 	return false;
			// }
			if(item.link){
				window.location.href = item.link
			}else{
				this.tab.id = item.id
			}
		},
		statusText(status){
			var text = ["敬请期待","即将开始","正在直播","已结束","直播回放"];
			return text[status-1];
		},
		setForm(item){
			this.room = item;
			this.getSession();
		},
		toSession(item,index){
			var status = this.sessionStatus(item,index);
			if(!this.tool.array.inArray(this.live_active,status)){
				return false;
			}else{
				if(item.live_url){
					window.open(item.live_url,'_blank');
				}else{
					//var url = this.global.MUDU_HOST +item.live_code;
					if(this.$store.state.user_info.id){
						var router = this.$router.resolve({
							path:"/auth",
							query:{
								live_event:item.live_event,
								live_code:item.live_code,
								live_type:item.live_type,
								title:item.title,
								//redirect:url
							}
						});
						window.open(router.href, '_blank');
					}else{
						var from = `/auth?live_code=${item.live_code}&live_type=${item.live_type}&live_event=${item.live_event}&title=${item.title}`;
						this.util.showAuth({
							show:true,
							from:from
						});
					}
				}
			}
		},
		inStar(row){
			return  this.star_list.find((item,index)=>{
				return Number(item.topic_id) === Number(row.id)
			})
		},
		star(item){
			if(!this.is_login){
				this.util.showAuth({
					show:true,
					from:"/plan"
				});
			}else{
				this.http.request({
					api:"user/star",
					data:{
						type:1,
						topic_id:item.id,
					},
					success:(res)=>{
						this.getStarList();
					}
				})
			}
		},
		getStarList(){
			if(!this.is_login){
				return false;
			}
			this.http.request({
				api:"user/starList",
				data:{
					type:1,
				},
				success:(res)=>{
					this.star_list = res.list;
				}
			})
		},
		sessionStatus(item,index){
			if(item.live_status > 0){
				return  item.live_status;
			}
			var now_time = this.now_time;
			if(now_time < parseInt(item.live_start)){
				if(index == 0){
					if(now_time < parseInt(item.live_start) - 30*60){
						return 1;
					}else{
						return 2;
					}
				}else{
					return 1;
				}
			}else if(now_time >= parseInt(item.live_start) && now_time < parseInt(item.live_end)){
				return 3;
			}else{
				return 4;
			}
		},
		removeKey(){
			this.key = "";
			this.getSession();
		},
		getTopic(){
			this.http.request({
				api:"main/getTopic",
				success:(res)=>{
					var list = res.list;
					list.map((item,index)=>{
						var issue = {};
						var speaker = [];
						if(item.issue && item.issue.length > 0){
							item.issue.map((v,i)=>{
								if(v.title){
									if(!issue[v.title]){
										issue[v.title] = [];
									}
									issue[v.title].push(v);
								}else{
									speaker.push(v);
								}
							})
						}
						item.issue = Object.getOwnPropertyNames(issue).length > 0 ? issue : false;
						item.speaker = speaker;
					})

					this.topic = list;
					if(this.tool.other.getUrlParams('timer') == 'local'){
						this.now_time = Math.floor(new Date().getTime()/1000);
					}else{
						this.now_time = res.service_time;
					}
					this.refresh();

					var time_list = [];
					for(var i =0;i<this.topic.length;i++){
						time_list.push(this.topic[i].live_start)
						time_list.push(this.topic[i].live_end);
					}
					this.time_list = time_list;

					this.$nextTick(()=>{
						this.data_loading = false;
						this.util.showBottom(true);
            this.fuckSister();
					})
				}
			})
		},
		refresh(){
			clearInterval(this.timer);
			this.timer = setInterval(()=>{
				this.now_time = this.now_time+1;
			},1000)
		},
    fuckSister() {
      const dom = document.querySelectorAll(".fuck-your-sister.active")[0];
      if (dom) {
        let top = document.querySelector(".m-header .top");
        if (top) {
          top = top.offsetHeight ? top.offsetHeight + 10 : 70;
        }
        const t = dom.getBoundingClientRect().top - top;
        document.body.scrollTop = document.documentElement.scrollTop = t;
      }
    },
	},
	mounted() {
		this.query = this.$route.query;
		this.getTopic();
		this.refresh();
		this.getStarList();
		this.swiperInit();
	},
	destroyed() {
		clearInterval(this.timer);
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.result{background: #F2F2F2 url("~@/assets/image/2024/mobile/bottom_bg.png") no-repeat bottom center;background-size: 100% auto;
	.branch{padding:.3rem;
		.swiper-container{padding:.1rem;display: none;
			.item{height:1.2rem;box-shadow: 0 0 .1rem .02rem rgba(0,0,0,.1); position: relative;cursor: pointer;text-align: center;transition: all .3s ease;background-repeat: no-repeat;background-position: center center;background-size: 100% 100%;
				.cen{display: inline-block;
					.middle{text-align: center;transition: all .3s ease;height:1.2rem;
						.icon{width:.58rem;height:.41rem;margin: 0 auto;
							img{display: block; width: 100%;height:100%;object-fit: contain;}
						}
						.icon-a{display: none;margin: 0 auto;}
						.tit{color:#2d576f;font-size:.24rem;line-height:.31rem;margin-top: .1rem;}
					}
				}
			}
			.item.active{transition: all .3s ease;background: url("~@/assets/image/b44.jpg") no-repeat center center;background-size: 100% 100%;
				.cen{
					.middle{
						.icon{display: none;}
						.icon-a{display: block;}
						.tit{color:#232846;}
					}
				}
			}
			.item:nth-last-child(1){margin-right: 0;}
		}
	}
	.title-box{overflow: hidden;padding: 0 .3rem .3rem;
		.date{height:1.11rem;line-height:1.11rem;font-size:.64rem;color:#0672cb;font-weight: 100;background: url("~@/assets/image/2021/10.png") no-repeat center center;background-size: contain;}
		.title{margin-left:.18rem;
			.tit{font-size: .36rem;margin-top: .18rem; line-height: .47rem;color:#0672cb;}
			.min-tit{font-size: .24rem;line-height:.31rem;margin-top:.15rem;color:#808080;}
		}
	}
	.list{overflow: hidden;padding: .3rem;
		.item{position: relative;display: flex;flex-wrap: wrap;overflow: hidden;
			.time-box{display: flex;flex-direction: column;width: 1.2rem;
				.line{position: relative;}
				.line::after{content: "";display: block;position: absolute;left:.15rem;top:0;width: 1px;height:100%;background: #979797;}
				.line-1{height:.2rem;}
				.line-2{flex: 1;}
				.time{font-size:.24rem;line-height:.3rem; font-weight: bold;text-align: right;position: relative;
					i{width: .3rem;height:.3rem; display: block;padding: .1rem 0; background: url("~@/assets/image/2021/14.png") no-repeat left center;background-size:.29rem;}
					.t{position: absolute;left:.4rem;top:.13rem;width: .75rem;}
				}
			}
			.info-box{padding-bottom:.3rem;flex: 1;
				.info{margin-left:.3rem; padding:.25rem .25rem .55rem;background: #fff;box-shadow: 0 0 .1rem .02rem  rgba(0,0,0,.1);position: relative;
					.title{font-size:.24rem;font-weight: bold;color:#1A1A1A;}
					.speaker{font-size:.22rem;line-height: .33rem; color:#808080;margin-top: .1rem;
						.ll{display: flex;
							span,i{display: block;float: left;}
							span:nth-child(1){min-width: .7rem;display: inline-block;text-align: justify;text-align-last: justify;}
							i{padding: 0 .1rem;}
							span:nth-last-child(1){flex: 1;}
						}
					}
					.issue{margin-top: .1rem; padding-top: .3rem;background: url("~@/assets/image/2021/18.png") no-repeat top center;background-size: 100% .16rem;overflow: hidden;
						.ll{margin-bottom:.4rem;
							.tit{font-size:.22rem;color:#0672cb;font-weight: bold;}
							.speaker-ll{font-size:.22rem;line-height: .33rem; color:#808080;margin-top:.1rem;display: flex;
								span,i{display: block;float: left;}
								span:nth-child(1){display: inline-block;}
								i{padding: 0 .1rem;}
								span:nth-last-child(1){flex: 1;}
							}
						}
						.ll:nth-child(2n){margin-right: 0;}
					}
					.status-box{position: absolute;bottom:0;right:0;display: flex;
						.status{width:1.35rem;height:.45rem;text-align: center;line-height:.5rem;background:#9F9F9F;color:#fff;font-size: .22rem;border-right: 1px solid #fff;
							p{padding-left:.2rem;background: url("~@/assets/image/2021/16.png") no-repeat left center;background-size:.12rem;display: inline-block;}
						}
						.status.active{background:#0672cb;}
						.star{width:1.35rem;height:.45rem;text-align: center;line-height:.5rem;background:#0672cb;color:#fff;font-size: .22rem;
							p{padding-left:.22rem;background: url("~@/assets/image/2022/10.png") no-repeat left center;background-size:.18rem;display: inline-block;}
							p::after{content: "收藏"}
						}
						.star.active{background:#9F9F9F;
							p{background-image: url("~@/assets/image/2022/11.png");background-size: .18rem;}
							p::after{content: "已收藏"}
						}
					}
				}
			}
		}
		.item.active{cursor: pointer;
			.time{background: url("~@/assets/image/2024/mobile/live_icon.png") no-repeat left center;background-size: .29rem;
        i{
          background: none;
        }
      }
		}
		.item:nth-last-child(1){padding-bottom: 0;}
	}
	.tips{text-align: left;color:#999;height:.8rem;line-height:.8rem;font-size:.24rem;padding: 0 .25rem;
		i{color:red;}
	}
}
</style>

